export function getShortenedStringWithDots(string, length = string.length) {
  return string.substring(0, length) + "...";
}
